import React from 'react';
import { Link } from 'react-router-dom';
// ANTD
import Form from 'antd/lib/form';
import Caption from 'components/text/Caption';
import message from 'antd/lib/message';
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';
// apollo
import { resetPassword } from 'meteor-apollo-accounts';
import ApolloClient from 'ApolloClient';
// MODULES
// COMPONENTS
import ErrorList from 'components/common/ErrorList';
import ErrorHelpers from 'lib/helpers/ErrorHelpers/index';
import PasswordInput from 'components/inputs/PasswordInput/index';

// CONSTANTS & DESTRUCTURING
// ====================================

// INTERNAL COMPONENTS
// ====================================
class EnrollForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitted: false,
      errors: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFields((err, { password, confirm }) => {
      if (err) {
        return;
      }
      resetPassword({ newPassword: password, token: this.props.token }, ApolloClient)
        .then(res => {
          ApolloClient.resetStore();
          this.props.history.push('/');
          return message.success('your password was reset!', 5);
        })
        .catch(err => {
          if (err.graphQLErrors && err.graphQLErrors[0] && err.graphQLErrors[0].message === 'Token expired [403]') {
            this.props.onExpiredToken();
            return console.log(err.graphQLErrors[0].message);
          }
          return ErrorHelpers.handleError(err, this);
        });
    });
  };

  checkPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you entered are inconsistent!');
    } else {
      callback();
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const newPasswordRules = [{ required: true, message: 'Please input a new password!' }];

    const repeatNewPassword = [
      { required: true, message: 'Please repeat the new password!' },
      { validator: this.checkPassword },
    ];

    if (this.state.submitted) {
      return (
        <div>
          <h3>Your password has been successfully reset!</h3>
        </div>
      );
    }

    return (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: 20 }}>
        <div className="ant-form-item" style={{ width: '100%' }}>
          {getFieldDecorator('password', { rules: newPasswordRules })(
            <PasswordInput size="large" prefix={<Icon type="lock" />} type="password" placeholder="New password" />,
          )}
        </div>
        <div className="ant-form-item" hasFeedback style={{ width: '100%' }}>
          {getFieldDecorator('confirm', { rules: repeatNewPassword })(
            <PasswordInput
              prefix={<Icon type="lock" />}
              type="password"
              size="large"
              placeholder="Repeat new password"
            />,
          )}
        </div>
        <div classsName="ant-form-item">
          <Button loading={this.state.loading} fullWidth htmlType="submit">
            Set & Login
          </Button>
        </div>
        <ErrorList errors={this.state.errors} />
        <div>
          <Caption>
            If you already created a password, then just <Link to="/login">login here</Link>.
          </Caption>
        </div>
      </Form>
    );
  }
}

export default Form.create()(EnrollForm);



// WEBPACK FOOTER //
// ./src/components/forms/EnrollForm/index.js